import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initQuantityInputs from '../components/quantityInputs';
import initProductVariants from '../components/product-variants';
import initRecommendedProducts from '../sections/product/recommended-products';
import initProductStickyAtc from '../components/product-sticky-atc';
import initKlaviyoBis from '../sections/product/klaviyo-bis';
import initLinkedSizeProducts from '../components/linked-size-products';
import initFabricSwatches from '../sections/product/fabricSwatches';
import initProductGalleryLightbox from '../sections/product/product-gallery-lightbox';
import initCompleteLook from '../sections/product/complete-look';

ready(() => {
  initQuantityInputs();
  initProductVariants();
  initLinkedSizeProducts();
  initRecommendedProducts();
  initProductStickyAtc();
  initKlaviyoBis();
  initFabricSwatches();
  initProductGalleryLightbox();
  initCompleteLook();
});

onShopifySectionLoad(() => {
  initRecommendedProducts();
  initCompleteLook();
});
